import { render, staticRenderFns } from "./LicenseOffers.vue?vue&type=template&id=152dac80&"
import script from "./LicenseOffers.vue?vue&type=script&lang=js&"
export * from "./LicenseOffers.vue?vue&type=script&lang=js&"
import style0 from "./LicenseOffers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports